// extracted by mini-css-extract-plugin
export var compact = "_ml-2";
export var phoneFrame = "_ml-0";
export var phoneScreen = "_ml-1";